<script>
    import user from "../stores/user";
    import charges from "../stores/charges";
    import {OBJECTS, SERVICE_TYPE} from "../lib/constants";
    import {createEventDispatcher} from 'svelte/internal';
    import {sort, formatDate, acronym} from "../lib/lib";
    import TableHeader from "../components/TableHeader.svelte";
    import ServiceSubscriptions from "./ServiceSubscriptions.svelte";
    import ChargeIcon from "../components/icons/ChargeIcon.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import TagsControl from "../components/controls/TagsControl.svelte";
    import ServiceColorName from "../components/controls/ServiceColorName.svelte";
    import UserInitials from "../components/controls/UserInitials.svelte";

    export let ws = null;
    if (ws) {
        user.ws(ws); // set current workspace for user
    }
    export let services = null;

    const dispatch = createEventDispatcher();

    let tableColumns = [
        {key: 'name', title: 'ΟΝΟΜΑ', sortable: true, sort_way: 'ASC'},
        {key: 'client_name', title: 'ΠΕΛΑΤΗΣ'},
        {key: 'tags', title: 'TAGS'},
        {key: 'price', title: 'ΤΙΜΗ', sortable: true},
        {key: 'start_at', title: 'ΕΝΑΡΞΗ', class: 'hidden-lg', sortable: true},
        {key: 'end_at', title: 'ΛΗΞΗ', sortable: true},
        {key: 'users', title: '', sortable: false},
        {key: '', title: ''},
        {key: '', title: ''},
        {key: '', title: ''},
    ];

    let serviceId = 0;
    let subscriptionsServiceId = null;


    const onEdit = (service) => {
        dispatch("edit", service);
    }

    const onRenew = (service) => {
        dispatch("renew", service);
    }

    const onDelete = (service) => {
        dispatch("delete", service);
    }

    const onShowSubscriptions = (service) => {
        if (service.ws_service.type == SERVICE_TYPE.SUBSCRIPTION) {
            serviceId = service.id;
            if (subscriptionsServiceId == service.id) {
                subscriptionsServiceId = null;
            } else {
                subscriptionsServiceId = service.id;
            }
        }
    }

    const onColumnSort = ({detail: column}) => {
        subscriptionsServiceId = null;
        services.sort_column = column;
        sortList();
    };


    const onCharge = item => {
        if (!item.charge_id) {
            charges.create(OBJECTS.SERVICE, item.id, {
                name: item.name,
                price: item.price || null,
                client: item?.client || null
            }, closeCharge);
        } else {
            charges.edit(item.charge_id, closeCharge);
        }
    }

    const closeCharge = param => {
        if (!param) {
            return;
        }
        let item = services.find(x => x.id == param.object_id);
        if (item) {
            item.charge_id = param.id;
            services = services;
        }
    }

    const sortList = () => {
        services = sort(services, services.sort_column.key, services.sort_column.sort_way === 'DESC');
    }
</script>


<table class="table table-list table-list-border">
    <TableHeader {tableColumns} on:sort={ onColumnSort }/>
    <tbody>
    {#each services as service}
        <tr class="row-hover" class:row-selected="{ serviceId === service.id }">
            <td>
                {#if service.ws_service.type == SERVICE_TYPE.SUBSCRIPTION}
                    <button class="btn-reset is-link btn-block" class:not-active={ service.is_active == 0 }
                            on:click="{ () => onShowSubscriptions(service) }">
                        <ServiceColorName {service}/>
                    </button>
                {:else}
                    <ServiceColorName {service}/>
                {/if}
            </td>
            <td class="text-gray">
                {#if service.client }
                    { service.client.name }
                {/if}
            </td>
            <td class="">
                <TagsControl tags={service.tags} service readonly/>
            </td>
            <td class="price-column text-gray text-end">
                {#if service.price}
                    { service.price }
                {/if}
            </td>
            <td class="date-column text-gray hidden-lg">
                {#if service.subscription}
                    { formatDate(service.subscription.start_at, 'd-m-y') }
                {/if}
            </td>
            <td class="date-column text-gray">
                {#if service.subscription}
                    { formatDate(service.subscription.end_at, 'd-m-y') }
                {/if}
            </td>
            <td class="users-column">
                <div class="d-flex align-items-center justify-content-end gap-1">
                    {#if service.users.length > 0}
                        {#each service.users as item}
                            <UserInitials user={item} md/>
                        {/each}
                    {/if}
                </div>
            </td>
            <td class="button-column">
                {#if service.ws_service.type == SERVICE_TYPE.SUBSCRIPTION}
                    <button class="button" title="ανανέωση" on:click="{ () => onRenew(service) }">
                        <AppIcon icon="renew"/>
                    </button>
                {:else}
                    <button class="button" title="χρέωση"
                            on:click={ () => onCharge(service) }>
                        <ChargeIcon active="{ service.charge_id }"/>
                    </button>
                {/if}
            </td>
            <td class="button-column">
                <button class="button" title="επεξεργασία" on:click="{ () => onEdit(service) }">
                    <AppIcon icon="edit"/>
                </button>
            </td>
            <td class="button-column">
                <button class="button" title="διαγραφή" on:click="{ () => onDelete(service) }">
                    <AppIcon icon="trash"/>
                </button>
            </td>
        </tr>
        {#if subscriptionsServiceId == service.id}
            <tr>
                <td class="container-column no-border" colspan="4"></td>
                <td class="container-column ps-0" colspan="{ tableColumns.length - 4 }">
                    <ServiceSubscriptions serviceId="{ subscriptionsServiceId }" {service}/>
                </td>
            </tr>
        {/if}
    {/each}
    </tbody>
</table>